import { checkUserValidity } from "./ExlyConnect.utils";
import { isRequestSuccessful } from "utils/Utils";
import { useExlyConnectStore } from "./store/useExlyConnectStore";
import { logError } from "utils/error";
import { useEffect } from "react";

export const useCheckValidExlyConnectUser = () => {
  const setIsValidZoomUser = useExlyConnectStore(
    (state) => state.setIsValidZoomUser
  );
  const setWebinarMinutes = useExlyConnectStore(
    (state) => state.setWebinarMinutes
  );

  useEffect(() => {
    handleCheckValidExlyConnectUser();
  }, []);

  const handleCheckValidExlyConnectUser = async () => {
    try {
      const response = await checkUserValidity();
      if (isRequestSuccessful(response?.status)) {
        if (response.data.exlycon_licenses > 0) {
          setIsValidZoomUser(true);
        } else {
          setIsValidZoomUser(false);
        }
        setWebinarMinutes(response.data.exlycon_webinar_minutes);
      }
    } catch (err) {
      setIsValidZoomUser(false);
      setWebinarMinutes(0);
      logError({
        error: err,
        occuredAt: "src/features/ExlyConnect/useCheckValidExlyConnectUser",
        when: "checking zoom user validity",
      });
    }
  };
};
